"use client";

import { scrollFieldIntoView } from "utils/scrollFieldIntoView";
import { LOCATION_COPY } from "@1-now/booking-core";
import { FC } from "react";

import { useData } from "data/data-provider";

import EndDateTimeRange from "designs/Common/(car-search-form)/endDateTime";
import StartDateTimeRange from "designs/Common/(car-search-form)/startDateTime";
import DropOffLocationInput from "designs/Common/DropOffLocationInput";
import SearchButton from "designs/DesignB/components/SearchButton/SearchButton";
import LocationInput from "../../../Common/LocationInput";

export interface RentalCarSearchFormProps {}

const MobileSearch: FC<RentalCarSearchFormProps> = () => {
  const { setDropoffLocationType, dropoffLocationType } = useData();

  const isDdropOffdifferent = dropoffLocationType === false;

  return (
    <form className="w-full relative py-8 px-4 content-center items-center rounded-md shadow-xl bg-secondary-50/50 backdrop-blur-xl z-40">
      <div
        className={`relative flex flex-col  ${
          isDdropOffdifferent ? "md:grid md:grid-cols-1 md:gap-2" : ""
        }`}
      >
        <div
          className={`${isDdropOffdifferent ? " " : "w-full my-2"}`}
          onClick={(e) => {
            if (window.innerWidth < 768) scrollFieldIntoView(e.currentTarget);
          }}
        >
          <LocationInput
            placeHolder={
              isDdropOffdifferent
                ? LOCATION_COPY.pickUp.label
                : LOCATION_COPY.same.label
            }
            desc={
              isDdropOffdifferent
                ? LOCATION_COPY.pickUp.prompt
                : LOCATION_COPY.same.prompt
            }
            className="w-full  rounded-md"
            sameDropOffLocation={dropoffLocationType === false}
            searchBar={false}
            onShowDropoffLocation={() => setDropoffLocationType(false)}
          />
        </div>
        {isDdropOffdifferent && (
          <div
            className="my-2"
            onClick={(e) => {
            if (window.innerWidth < 768) scrollFieldIntoView(e.currentTarget);
          }}
          >
            <DropOffLocationInput
              placeHolder={LOCATION_COPY.dropOff.label}
              desc={"Location"}
              className="w-full rounded-md"
              divHideVerticalLineClass="-inset-x-0.5"
            />
          </div>
        )}
      </div>
      <div className="relative flex flex-col">
        <StartDateTimeRange className="flex-1" />

        <EndDateTimeRange
          dropOffLocationType={dropoffLocationType}
          className="w-full rounded-md my-2"
        />
      </div>
      <SearchButton />
    </form>
  );
};

export default MobileSearch;
